import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import { isSubmitting, isValid, submit } from 'redux-form';

import Form from './WorkflowReduxForm';

import { FORM_NAME } from './index';
import { setWorkflowData } from '../../../redux/workflow';

import PageBase from '../../../app/PageBase';

const mapStateToProps = state => ({
  submitting: isSubmitting(FORM_NAME)(state),
  valid: isValid(FORM_NAME)(state),
  workflowId: state.workflowReducer.workflowId,
  open: state.workflowReducer.open,
  workflowData: state.workflowReducer.workflowData,
  isFinished: state.workflowReducer.isFinished,

});
const mapDispatchToProps = {
  submit,
  setWorkflowData,
};

class WorkflowForm extends Component {

  static propTypes = {

  };

  static defaultProps = {

  };

  constructor(props) {

    super(props);

  }


  submit = () => {

    this.props.submit(FORM_NAME);

  }

  close = () => this.props.history.push('/flow/incompleteList/');

  onSubmitSuccess = () => this.props.onSubmitSuccess();

  onActivateSave = condition => this.props.setWorkflowData({ isFinished: true })

  render() {

    const {
      open, workflowId, workflowData, submitting, valid, consultMode, isFinished,
    } = this.props;


    return (

      <div>

        <PageBase
          title={I18n.t('titles.new_workflow')}
          showSaveButton
          handleCloseClick={this.close}
          handleSaveClick={this.submit}
          disableSaveButton={submitting || !valid}
        >
          <Form
            id={workflowId}
            onActivateSave={this.onActivateSave}
            onSaveComplete={this.close}
          />


        </PageBase>


      </div>


    );

  }

}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkflowForm));



// WEBPACK FOOTER //
// ./src/components/tracker/Flow/WorkflowForm.js